import config from "../core/config";

/**
 * Submit a Microsoft waitlist entry to the backend.
 *
 * @example
 * await submitMicrosoftWaitlist({
 *   work_email: "alex@contoso.com",
 *   full_name: "Alex Kim",
 *   source: "web",
 * });
 * // => { message: "You're on the waitlist..." }
 */
export async function submitMicrosoftWaitlist(payload) {
  const response = await fetch(`${config.BACKEND_URL}/waitlist/microsoft`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Failed to join the waitlist.");
  }

  return data;
}
